import { render, staticRenderFns } from "./chatsVigentes.vue?vue&type=template&id=b49651b6&scoped=true"
import script from "./chatsVigentes.vue?vue&type=script&lang=js"
export * from "./chatsVigentes.vue?vue&type=script&lang=js"
import style0 from "./chatsVigentes.vue?vue&type=style&index=0&id=b49651b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49651b6",
  null
  
)

export default component.exports